<template>
	<vxe-grid class="" v-bind="list_gridOptions" v-if="list_gridOptions"
		@toolbar-button-click="list_toolbarButtonClickEvent" :ref="reportName+'_list'">
	</vxe-grid>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {

		},
		data() {
			return {
				outputmerge: [],
				list_formConfig: [{
					field: 'date',
					title: '统计月份',
					resetValue: this.$Moment().startOf('month').valueOf(),
					itemRender: {
						defaultValue: this.$Moment().startOf('month').valueOf(),
						name: '$datePicker',
						props: {
							type: 'month'
						}
					}
				}],
				list_footerField: [{
					type: 'seq',
					field: 'code',
					title: '汇总',
				}, {
					type: 'field',
					field: 'invoicepreamount',
					toFixed: 2
				}],
				reportName: 'invoice',
				windowName: '发票统计',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {


		},
		computed: {

		},

		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 300
				// gridOptions.formConfig.span = 4
				gridOptions.formConfig.enabled = false
				gridOptions.columns = [{
					type: 'seq',
					title: '序号',
					width:50,
				},{
					field: 'number',
					title: '单据编码',
				}, {
					field: 'ordercode',
					title: '系统单号'
				}, {
					field: 'invoicetitle',
					title: '购方名称'
				}, {
					field: 'invoicepreamount',
					title: '预开票金额'
				}, {
					field: 'commit_time',
					title: '申请时间',
					formatter:({cellValue})=>{
						return window.systemMethods.timestampToDate(cellValue)
					}
				}, {
					field: 'invoicestatus',
					title: '开票状态',
					formatter:({cellValue})=>{
						return window.systemMethods.getEmunValue('invoicestatus',cellValue)
					},
					width:100,
				}, {
					field: 'issend',
					title: '是否发送',
					formatter:({cellValue})=>{
						let issend = window.systemMethods.getEmunValue('enable',cellValue)
						return issend?issend:'否'
					},
					width:100,
				}]
			},
			list() {
				return new Promise(resolve => {
					this.$api.invoice.applyinvoice().then((res) => {
						resolve({
							list: res
						})
					}, () => {
						resolve([])
					})
				})
			}

		},
		components: {

		}
	}
</script>